import { OPTIONS_INTEGRATION } from 'app-constants'
import { http } from 'hooks'

export function customerService() {
  function getCustomer() {
    return http.get('/v1/customers', OPTIONS_INTEGRATION)
  }

  function getCouponCode() {
    return http.post('/v1/customers/generate-coupon', {}, OPTIONS_INTEGRATION)
  }

  return { getCustomer, getCouponCode }
}
